var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldIcon192(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 0C56.5204 0 24.4021 32.1312 24.4021 71.6263C24.4021 130.471 88.8734 187.929 91.6189 190.346C92.8705 191.449 94.4349 192.001 96 192.001C97.5651 192.001 99.1295 191.449 100.382 190.346C103.126 187.929 167.598 130.472 167.598 71.6263C167.598 32.1312 135.48 0 96 0ZM96 176.284C81.7461 162.471 37.6611 116.144 37.6611 71.6263C37.6611 39.4427 63.8319 13.259 96 13.259C128.168 13.259 154.339 39.4427 154.339 71.6263C154.339 116.143 110.254 162.471 96 176.284Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 38.2598C77.7225 38.2598 62.8531 53.228 62.8531 71.6264C62.8531 90.0254 77.7225 104.993 96 104.993C114.277 104.993 129.147 90.0254 129.147 71.6264C129.147 53.228 114.277 38.2598 96 38.2598ZM96 91.734C85.0334 91.734 76.1115 82.7139 76.1115 71.6264C76.1115 60.5395 85.0334 51.5188 96 51.5188C106.967 51.5188 115.888 60.5389 115.888 71.6264C115.888 82.7139 106.967 91.734 96 91.734Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldIcon192);
export default __webpack_public_path__ + "static/media/world-icon192.1faf2cd19d70963522b6a710260660f3.svg";
export { ForwardRef as ReactComponent };